module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "forum-post-result"
  }, [_c('ForumAvatar', {
    attrs: {
      "src": _vm.getAvatarUrl(_vm.post)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "post-body"
  }, [_c('div', {
    staticClass: "post-meta"
  }, [_c('div', {
    staticClass: "post-context"
  }, [_c('router-link', {
    staticClass: "author-name",
    attrs: {
      "to": _vm.getAuthorUrl(_vm.post)
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.getAuthorName(_vm.post)) + "\n                ")]), _vm._v(" "), (_vm.getAuthorRole(_vm.post)) ? _c('span', {
    staticClass: "author-role"
  }, [_c('img', {
    attrs: {
      "src": _vm.getAuthorRoleIcon(_vm.post),
      "title": _vm.getAuthorRole(_vm.post)
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("in")]), _vm._v(" "), _c('router-link', {
    staticClass: "thread-title",
    attrs: {
      "to": _vm.threadUrl
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.thread.title) + "\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "post-date"
  }, [(_vm.hasBeenEdited(_vm.post)) ? _c('span', {
    staticClass: "edit-status",
    attrs: {
      "title": _vm.editStatus(_vm.post)
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "title": _vm.postStatus(_vm.post)
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.prettyPostDate(_vm.post)) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "post-content"
  }, [_vm._t("post-content", _vm._l((_vm.post.excerpts), function(excerpt) {
    return _c('p', {
      domProps: {
        "innerHTML": _vm._s(excerpt)
      }
    })
  }))], 2), _vm._v(" "), _c('div', {
    staticClass: "post-actions"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.postUrl
    }
  }, [_vm._v("\n                Go to post\n                "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56fc5662!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/post-result.vue
// module id = 2051
// module chunks = 2